import { render, staticRenderFns } from "./a-loading-spinner.vue?vue&type=template&id=818d5fa8&scoped=true&"
import script from "./a-loading-spinner.vue?vue&type=script&lang=js&"
export * from "./a-loading-spinner.vue?vue&type=script&lang=js&"
import style0 from "./a-loading-spinner.vue?vue&type=style&index=0&id=818d5fa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818d5fa8",
  null
  
)

export default component.exports